/* eslint-disable import/no-anonymous-default-export */
export default {
	styleOverrides: {
		paper: {
			padding: '10px 0px 0px 0px',
		},
	},
};
